<svg class="{{classes}}">
  <use [attr.href]="'/sprite.svg#sprite-' + name"></use>
</svg>